const wrapElement = document.querySelector('.toshi__dialog');
const btnElement = document.querySelector('.toshi__btn');

const onBtnClick = (evt) => {
  evt.preventDefault();
  wrapElement.classList.add('toshi__dialog--opened');
};

const initToshiPreview = () => {
  btnElement.addEventListener('click', onBtnClick);
};

export default initToshiPreview;
